import React, { useEffect, useState } from "react";
import { IF } from "../../../../../../../components/hoc/If";
import { useCurrentOrganisationId } from "../../../../../../../services/local/organisationContext/OrganisationContextModel";
import { JobRolesGridModel } from "./JobRolesGrid_model";
import { GridView } from "../../../../../../../core/grids/GridView_view";
import { JobRolesGridViewModel } from "./JobRolesGridView_model";
import { Button, ButtonTypes } from "../../../../../../../components/ui/Button";
import { Enums, UiSizes } from "../../../../../../../enums";
import { observer } from "mobx-react";
import { Input } from "../../../../../../../components/ui/_forms/Input";
import { IconSymbols } from "../../../../../../../components/ui/Icon";
import { useFlightPathUser } from "../../../../../../../core/auth_insight";
import { PositionedSpinner } from "@flightpath/coreui/dist/ui/PositionedSpinner";
import { ButtonIcon, ButtonIconShapes } from "@flightpath/coreui/dist/ui/Button";
import ModalContext from "../../../../../../../core/modalZ/context/ModalContext";
import { useParams } from "react-router-dom";

export const JobRolesGrid: React.FC<{ onAssignSuccess: () => void }> = observer(({ onAssignSuccess }) => {
  const { projectId } = useParams();
  const organisationId = useCurrentOrganisationId();
  const authUser = useFlightPathUser();
  const [model] = useState(() => new JobRolesGridModel(+projectId, organisationId, authUser));
  const [gridModel] = useState(() => new JobRolesGridViewModel(organisationId, +projectId, authUser));

  useEffect(() => {
    model.onMount();
    return model.onUnmount;
  }, [model]);

  if (model.isLoading) return <PositionedSpinner />;

  return (
    <div className="job-roles-grid">
      <div className="container-fluid py-3">
        <div className="row">
          <div className="col-10">
            <Button
              type={ButtonTypes.OUTLINE_PRIMARY}
              size={UiSizes.SM}
              isDisabled={model.selectedJobRoles.length === 0}
              className="mt-2 mr-2 align-self-start"
              onClick={async () => {
                let res = await model.assignJobRoles();
                if (res) {
                  onAssignSuccess();
                }
              }}
            >
              Assign
            </Button>
            <Input
              autoFocus={true}
              className="mt-2"
              size={UiSizes.XS}
              onChange={model.setSearchText}
              placeholder="Search"
              icon={IconSymbols.Search}
              iconSize={Enums.UiSizes.SM}
              iconClass="mt-1"
              style={{ height: 32 }}
            />
          </div>
          <div className="col-2 d-flex align-items-end px-0 justify-content-end">
            <ButtonIcon
              size={UiSizes.SM}
              onClick={ModalContext.hide}
              type={ButtonTypes.OUTLINE_PRIMARY}
              shape={ButtonIconShapes.RECTANGLE}
              symbol={IconSymbols.Close}
            />
          </div>
        </div>
      </div>
      <IF condition={!model.isLoading}>
        <GridView
          context={{}}
          data={model.gridData}
          users={[]}
          onCellClicked={() => {}}
          onCellEditModeChange={() => {}}
          onSelectionChanged={model.updateSelectedJobRoles}
          model={gridModel}
          isLoading={gridModel.isLoading}
          onGridReady={model.onGridReady}
          // ref={filterRef}
          // filterHasChangedFn={setHasFilters}
          // isExternalFilterPresent={model.isExternalFilterPresent}
          // doesExternalFilterPass={model.doesExternalFilterPass}
          overlayNoRowsTemplate={null}
        />
      </IF>
    </div>
  );
});
